import React, { useState } from 'react';
import './VersionUpdateModal.css';

// Blocking modal shown when useVersionCheck detects a new deployment.
// One action: reload. We also try to clear any service-worker / Cache
// Storage entries before reloading, in case a future PWA setup ever
// caches assets.

export default function VersionUpdateModal({ currentVersion, latestVersion }) {
  const [reloading, setReloading] = useState(false);

  async function handleReload() {
    setReloading(true);
    try {
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch {
      // Ignore — best effort.
    }
    window.location.reload();
  }

  return (
    <div className="version-update-overlay" role="dialog" aria-modal="true">
      <div className="version-update-modal">
        <div className="version-update-icon" aria-hidden="true">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="23 4 23 10 17 10" />
            <polyline points="1 20 1 14 7 14" />
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
          </svg>
        </div>
        <h2 className="version-update-title">A new version is available</h2>
        <p className="version-update-body">
          The app has been updated. Please reload to get the latest version —
          continuing on the old version may cause errors.
        </p>
        <div className="version-update-versions">
          <span>Current: <code>{currentVersion}</code></span>
          <span className="arrow">→</span>
          <span>Latest: <code>{latestVersion}</code></span>
        </div>
        <div className="version-update-actions">
          <button
            className="btn btn-primary"
            onClick={handleReload}
            disabled={reloading}
          >
            {reloading ? 'Reloading…' : 'Reload now'}
          </button>
        </div>
      </div>
    </div>
  );
}
